import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsPnr extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>PNR and Train Status</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I check the PNR status of my booking?</h3>
                            <p>You can check your PNR status through</p>
                            <li><span>Via RailYatri App:</span> Open the app, go to "PNR Status," and enter your PNR number to view the status.</li>
                            <li><span>Via IRCTC Website/App:</span> Log in, navigate to "PNR Status," and enter your PNR number.</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What do the different status codes (WL, RAC, CNF) in PNR mean?</h3>
                            <p>The status codes in your PNR (Passenger Name Record) indicate the current status of your train ticket booking in India. Here's what the most common status codes mean:</p>

                            <p>1. WL (Waiting List)</p>
                            <ul>
                                <li><span>WL (Waiting List)</span> means your ticket is currently not confirmed, and you are on the waitlist.</li>
                                <li>Passengers with a waitlisted ticket are not guaranteed a seat or berth unless the ticket status changes to RAC or CNF.</li>
                                <li>As cancellations occur, your ticket may move up the waitlist and eventually get confirmed.</li>
                                <li>If your ticket is still WL after the chart is prepared (usually 3-4 hours before departure), you will not be allowed to board the train, and your ticket will be automatically canceled and refunded.</li>
                            </ul>

                            <p>2. RAC (Reservation Against Cancellation)</p>
                            <ul>
                                <li><span>RAC (Reservation Against Cancellation)</span> means you have a seat, but not a confirmed berth.</li>
                                <li>With an RAC ticket, you will be assigned a shared seat with another RAC passenger (usually two passengers share a single berth, often a side lower berth).</li>
                                <li>If there are cancellations, your RAC ticket may get upgraded to CNF (Confirmed), and you will get a full berth.</li>
                            </ul>

                            <p>3. CNF (Confirmed)</p>
                            <ul>
                                <li><span>CNF (Confirmed)</span> means your ticket is confirmed, and you have a reserved seat or berth.</li>
                                <li>The seat or berth number will be provided either at the time of booking or when the final chart is prepared (3-4 hours before departure).</li>
                                <li>A confirmed ticket ensures that you will have a guaranteed seat or berth on the train.</li>
                            </ul>

                            <p>4. Other Common Status Codes</p>
                            <ul>
                                <li><span>GNWL (General Waiting List)</span>: This is the most common type of waiting list for general quota bookings. It's more likely to get confirmed compared to other waitlists.</li>
                                <li><span>TQWL (Tatkal Waiting List)</span>: This is the waiting list for tickets booked under the Tatkal quota. These tickets have lower chances of confirmation compared to GNWL.</li>
                                <li><span>PQWL (Pooled Quota Waiting List)</span>: A waiting list for tickets under the pooled quota, which covers small intermediate stations.</li>
                                <li><span>RLWL (Remote Location Waiting List)</span>: A waiting list for tickets booked for stations on specific routes or remote locations.</li>
                                <li><span>NOSB (No Seat Berth)</span>: This applies to children under 12 years of age who have been booked without a separate seat or berth.</li>
                                <li><span>CAN (Cancelled)</span>: The ticket has been canceled.</li>
                                <li><span>REGRET/WL</span>: Indicates that the waiting list is closed, and no more bookings are allowed.</li>
                            </ul>

                            <p>These codes change dynamically as cancellations and upgrades happen, so it's important to check your PNR status regularly, especially closer to the journey date.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>Can I modify the PNR details after booking?</h3>
                            <p><span>No, you cannot modify PNR details via the RailYatri app or website.</span></p>

                            <p>To make changes to your PNR details, you will need to:</p>

                            <li>Visit the nearest Indian Railways reservation counter.</li>
                            <li>Bring a printout of your e-ticket, valid identity proof, and a written application for the name change.</li>
                            <p>This process is managed directly through Indian Railways, as PNR modifications cannot be done online through RailYatri.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I find the coach position or platform number for my train?</h3>
                            <p>To check your Coach Position</p>

                            <li>Open the RailYatri app and go to the <span>"Upcoming Trip"</span> section.</li>
                            <li>Click <span>"Check PNR Status"</span>.</li>
                            <li>Find <span>"Coach Position"</span> under the <span>"E Helpdesk"</span> section.</li>


                            <p>For the Platform Number,</p>
                            <p>Use the <span>"Time Table"</span> or <span>"Live Train Status"</span> sections on the app or website to view the expected platform for your train.</p>

                            <p>Disclaimer:</p>
                            <p>Coach position and platform number information is based on the latest data but may change. Always verify these details at the station or through official railway sources for accuracy.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How can I track the live status of my train?</h3>
                            <p>1. Track via RailYatri App/Website</p>
                            <p>• RailYatri App:</p>
                            <li>Open the <span>RailYatri app</span> on your smartphone.</li>
                            <li>On the home screen, tap on <span>"Live Train Status"</span>.</li>
                            <li>Enter your train number or train name.</li>
                            <li>Select the station you want to check the status for (departure or arrival).</li>
                            <li>The app will display the train's current location, expected time of arrival (ETA), and any delays.</li>


                            <p>• RailYatri Website:</p>

                            <li>Visit the <span>RailYatri website</span>.</li>
                            <li>Click on <span>"Live Train Status"</span> from the main menu.</li>
                            <li>Enter your train number or name and the station of interest.</li>
                            <li>Real-time updates on the train's location and any delays will be displayed.</li>

                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I change my boarding point after booking?</h3>
                            <li>Step 1: Open the <span className="highlight">RailYatri App</span>: Launch the app on your device and log in if required.</li>
                            <li>Step 2: Go to <span className="highlight">"My Bookings"</span>: Look for the specific ticket for which you want to change the boarding point.</li>
                            <li>Step 3: Tap on the ticket to open the detailed view.</li>
                            <li>Step 4: Find the <span className="highlight">Boarding Point Option</span>: In the ticket details, look for an option like <span className="highlight">"Change Boarding Point"</span> (the label may vary by app version).</li>
                            <li>Step 5: Select the <span className="highlight">New Boarding Point</span> available on your train route.</li>
                            <li>Step 6: Confirm the Change: After selecting the new boarding point, confirm the change. The app will notify you if the change is successful.</li>
                            <p><strong>Note:</strong> Boarding point changes can generally be made up to 24 hours before the scheduled departure of the train.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsPnr);
